import { __ } from '@/hub-shared/utils/i18n';

export type PermissionLabel = {
  label: string;
  description: string;
};

export const PERMISSION_LABELS = (): Record<string, PermissionLabel> => ({
  ownership_transfer: {
    label: __('Transfert de propriété'),
    description: __(
      'Transférer la propriété du compte cabinet à un autre utilisateur. Uniquement disponible pour le rôle « Propriétaire ».',
    ),
  },
  cabinet_edit: {
    label: __('Gérer les paramètres cabinet'),
    description: __('Modifier les paramètres globaux du cabinet et du logiciel.'),
  },
  cabinet_manage_control_level: {
    label: __('Gérer le contrôle et la conformité'),
    description: __('Configurer les exigences documentaires et les règles de conformité des missions.'),
  },
  connections_manage_api: {
    label: __('Gérer les connexions API aux logiciels tiers'),
    description: __('Ajouter, modifier, supprimer des connexions API à des logiciels externes.'),
  },
  billing_manage: {
    label: __('Gérer la facturation'),
    description: __("Accéder et gérer les informations de facturation et d'abonnement du cabinet."),
  },
  users_manage_access: {
    label: __('Gérer les rôles utilisateurs'),
    description: __('Modifier les droits et accès des utilisateurs.'),
  },
  users_manage: {
    label: __('Gérer les utilisateurs'),
    description: __('Modifier, supprimer et inviter des utilisateurs.'),
  },
  companies_manage: {
    label: __('Gérer les dossiers clients'),
    description: __('Modifier, supprimer et archiver les dossiers clients.'),
  },
  companies_manage_clients: {
    label: __('Attribuer les dossiers clients'),
    description: __('Associer des dossiers clients à des utilisateurs du cabinet.'),
  },
  missions_start: {
    label: __('Démarrer une mission'),
    description: __('Lancer une mission VS pour un dossier client.'),
  },
  missions_close: {
    label: __('Clôturer une mission'),
    description: __('Clôturer une mission VS générée.'),
  },
  missions_archive: {
    label: __('Archiver une mission'),
    description: __('Archiver définitivement une mission VS signée.'),
  },
  reports_fill: {
    label: __('Remplir le formulaire VS'),
    description: __('Éditer et compléter le rapport VS.'),
  },
  reports_workfile: {
    label: __('Accéder au dossier de travail'),
    description: __('Ouvrir le dossier de travail dans l’interface cabinet (portail VS).'),
  },
  files_delete: {
    label: __('Supprimer des fichiers du dossier'),
    description: __('Supprimer définitivement un fichier déposé dans les fichiers du dossier.'),
  },
  reports_control: {
    label: __('Contrôler la mission VS'),
    description: __('Niveau de contrôle des diligences de la mission VS.'),
  },
  reports_generate: {
    label: __('Générer la mission'),
    description: __('Générer les livrables VS de la mission.'),
  },
  reports_export: {
    label: __('Exporter les livrables'),
    description: __('Exporter la mission et le dossier de travail.'),
  },
});

export const PERMISSION_GROUP_LABELS = (): Record<string, string> => ({
  cabinet: __('Paramètres du cabinet'),
  users: __('Gestion des utilisateurs'),
  vsme: __('Missions VS (vsme)'),
});
